// actions.js
import { RESET } from '../constants/ActionTypes';

export const resetObject = (serviceName) => ({
  type: RESET,
  serviceName: serviceName,
});
